<template>
  <div class="braintree">
  <v-card :loading="waiting">

    <v-card-text v-if="!complete">
      <div id="dropin-container" :class="{hidden:hide}"></div>
      <v-btn v-if="!waiting" @click="submit">Submit Payment</v-btn>
    </v-card-text>

    <v-card-text v-if="complete">
    Transaction successfull
    </v-card-text>

  </v-card>
  </div>
</template>

<script>
//import _ from 'lodash'
import dropin from 'braintree-web-drop-in'
import axios from '../lib/axios'
const log = console.log

/*
const TRANSACTION_SUCCESS_STATUSES = [
  'authorizing',
  'authorized',
  'settled',
  'settling',
  'settlement_confirmed',
  'settlement_pending',
  'submitted_for_settlement'
]
*/

export default {
  props: {
      stake : Object
  },
  data: () => ({
    waiting: false,
    btClient: null,
    complete: false,
    hide: false,
  }),
  mounted() {
      let self = this
      self.waiting = true
      dropin.create({
          authorization: 'sandbox_9q3x8dsp_x8d6qycq8k6h7dsh',
          container: document.getElementById("dropin-container"),
      }, function (createErr, instance) {
          self.waiting = false
          if (createErr) console.log('ERROR','BrainTree:mounted',createErr)
          self.btClient = instance
      });
  },
  methods: {
    setMessage (message) {
this.$store.commit('showMessage', { content: message, color: 'info' })
    },
    setError (message) {
this.$store.commit('showMessage', { content: message, color: 'error' })
    },
    submit() {
        let self = this
//        self.setMessage('Submitting transaction...')
        self.hide = true
        self.btClient.requestPaymentMethod(function (err, payload) {
            if (err) {
                console.log('ERROR','BT.requestPaymentMethod:Error', err);
                self.setError("Submission unsucessful")
                return;
            }
            // Submit payload.nonce to your server
            var nonce = payload.nonce

            self.waiting = true
            axios.post('/api/checkout', {
                "nonce": nonce,
                "stake": self.stake
            })
            .then(function (response) {
                self.waiting = false
              self.btClient.teardown(function (teardownErr) {
                if (teardownErr) {
                  console.error('ERROR','BrainTree', 'Could not tear down Drop-in UI!');
                } 
              });
              if (response.data.success) {
                  self.setMessage('Transaction completed successfully')
                  self.complete = true
              } else {
                  log('ERROR','BrainTree:checkout',response)
                  self.setError('Transaction was unsuccessful')
              }
            })
            .catch(function (err) {
                console.log('ERROR','POST checkout ERROR', err)
                self.setError('Transaction did not succeed. (Check logs.)')
            })

       });

       return false
    }
  }
}
</script>

<style scoped>
.braintree {
    margin-left: auto;
    margin-right: auto;
    width: 400px;
    height: 400px;
}
.braintree td {
    text-align: left;
    width: 50%;
}
.braintree-submit {
    margin-left: auto;
    margin-right: auto;
}
.hidden {
    display: none;
}

@keyframes spinner {
      to { transform: rotate(360deg); }
}
.fa-spinner {
        animation: spinner 1s linear infinite;
}


</style>
